import React from 'react'
import { ReactComponent } from './delivery-box.svg'
import { MergeReactElementProps } from '../types'

interface DeliveryBoxProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', DeliveryBoxProps>

export const DeliveryBoxIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = 'white' } = props
    return (
      <ReactComponent
        stroke={color}
        fill='none'
        ref={ref}
        {...props}
        stroke-width='2'
      />
    )
  }
)
